import DashboardIcon from '@mui/icons-material/Dashboard';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ProductionQuantityLimitsRoundedIcon from '@mui/icons-material/ProductionQuantityLimitsRounded';
import { HeaderButtonInterface } from 'Interfaces/IGlobalTypeConfig';
import { Link } from 'react-router-dom';

export const OrderHeaderButtonDetails = (
  linkId1: string | null,
  linkId2: string | null
): HeaderButtonInterface[] => [
  {
    name: 'order.headerButtons.unmanaged',
    component: { Link },
    to: `/orders`,
    icon: DashboardIcon,
  },
  {
    name: 'order.headerButtons.ordered',
    component: { Link },
    to: `/orders/ordered`,
    icon: ProductionQuantityLimitsRoundedIcon,
  },
  {
    name: 'order.headerButtons.history',
    component: { Link },
    to: `/orders/OrderHistory`,
    icon: LocalShippingIcon,
  },
];
